import { css } from 'styled-components';
import { complementaryColors } from '../../atoms/colors/complementary-colors';
import { colors } from '../../atoms/colors/colors';
import { dropdownCommonTheme } from './common-theme';
export const dropdownDarkTheme = {
    ...dropdownCommonTheme,
    trigger: css `
    ${dropdownCommonTheme.trigger}
    --error-color: ${colors.red500};
    --border-color: ${complementaryColors.warmgrey650};
    --background-color: ${colors.warmgrey800};
    --color: ${colors.warmgrey300};
    --disabled-color: ${complementaryColors.warmgrey650};
    --placeholder-color: ${colors.warmgrey500};
  `,
    triggerIcon: css `
    ${dropdownCommonTheme.triggerIcon}
    --color: ${colors.warmgrey500};
  `,
    content: css `
    ${dropdownCommonTheme.content}
    --background-color: ${colors.warmgrey800};
    --scroll-icon-color: ${colors.warmgrey500};
    --section-label-color: ${colors.warmgrey300};
    --separator-color: ${colors.warmgrey500};

    box-shadow: 0px 10px 38px -10px rgba(0, 0, 0, 0.8),
      0px 10px 20px -15px rgba(0, 0, 0, 0.4);
  `,
    item: css `
    ${dropdownCommonTheme.item}
    --color: ${colors.warmgrey500};
    --focus-background-color: ${colors.warmgrey700};
    --active-background-color: ${colors.warmgrey750};
    --active-color: ${colors.warmgrey300};
    --disabled-text-color: ${complementaryColors.warmgrey650};
    --netagive-color: ${colors.red500};
  `,
};
//# sourceMappingURL=dark-theme.js.map